import React from 'react';
import ReactDOM from 'react-dom/client';
import { TagadaHeadlessProvider } from '@tagadapay/headless-sdk/react';
import App from './App';
import './styles.css';

function Providers({ children }: { children: React.ReactNode }) {
  const storeId = import.meta.env.VITE_TAGADA_STORE_ID as string | undefined;
  const environment = (import.meta.env.VITE_TAGADA_ENVIRONMENT ?? 'production') as
    | 'production'
    | 'development'
    | 'local';

  if (!storeId) {
    return <>{children}</>;
  }

  return (
    <TagadaHeadlessProvider storeId={storeId} environment={environment}>
      {children}
    </TagadaHeadlessProvider>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Providers>
      <App />
    </Providers>
  </React.StrictMode>
);
